import { type WorkshopShell } from '../../dashboards/workshopDetailUrlFor';
import { BookingFilters } from '../BookingFilters';
import { BookingKpiStrip } from '../BookingKpiStrip';
import type { useBookingsList } from '../useBookingsListState';

import { BookingResults } from './BookingResults';

/** The original Bookings view, unchanged — extracted so the page component
 *  stays legible now that it switches between two of them. */
export function BookingsTabBody({
  s,
  isDesktop,
  isTablet,
  shell,
}: {
  s: ReturnType<typeof useBookingsList>;
  isDesktop: boolean;
  isTablet: boolean;
  shell: WorkshopShell;
}) {
  return (
    <>
      <BookingKpiStrip stats={s.stats} />

      <BookingFilters
        status={s.status}
        onStatusChange={s.setStatus}
        source={s.source}
        onSourceChange={s.setSource}
        search={s.searchInput}
        onSearchChange={s.setSearchInput}
        sort={s.sort}
        dir={s.dir}
        onSortChange={s.setSort}
        onDirToggle={s.toggleDir}
        isDesktop={isDesktop}
      />

      <BookingResults s={s} isDesktop={isDesktop} isTablet={isTablet} shell={shell} />
    </>
  );
}
